<template lang="pug">
div.wrap-atom-new-asset
  //- h1(style="position:fixed; width: 100px; left: 0; top: 100px;") test
  div.sub-header.f.flex-between
    div(v-for="tab in tabs" @click.stop="currentTab = tab"
      :class="{'active': tab == currentTab}"
      :style="`width: ${100 / tabs.length}%;`").tab.f.fh
      span.fz14 {{tab}}
  div(v-if="currentTab == '新規'").new-asset.px10.py10
    div.wrap-upload-area
      AssetUploader(@setParentAsset="setParentAsset")
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
$max_new_asset_window_width: 640px;
.wrap-atom-new-asset {
  position: absolute;
  width: 50vw;
  max-width: $max_new_asset_window_width;
  top: 0;
  left: calc(100% + 12px);
  background: $primary_bg_color;
  border-radius: 3px;
  box-shadow: $box_shadow;
  overflow: hidden;
  .sub-header {
    width: 100%;
    height: 28px;
    background: $dark_primary_bg_color;
    .tab {
      &.active {
        border-bottom: solid 2px #fff;
      }
      span {
        color: $dark_primary_text_color;
      }
    }
  }
  .new-asset {
    .wrap-upload-area {
      height: 280px;
    }
  }
}
</style>

<script>
import database from '@/database'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')
import AssetUploader from '@/components/shared/AssetUploader'

export default {
  components: {
    AssetUploader
  },
  props: {
    assetType: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      currentTab: '新規',
      tabs: ['新規', '検索'],
      parentAsset: null
    }
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  async created () {

  },
  methods: {
    setParentAsset (asset) {
      this.parentAsset = asset
    }
  }
}
</script>
